//
export const AUTO_FILL_MAP = {
  // 投放作品
  投放作品: {
    h5: "http://{公众号appid}.book-gzh.ledu11.cn/referral/{投放作品id}",
    mini: "/pages/reader/reader?referral_id={投放作品id}&gzh_appid={公众号appid}",
    reg: /\/referral\/(\d+)$/,
    key: "{投放作品id}",
  },
  其他作品: {
    h5: "http://{公众号appid}.book-gzh.ledu11.cn/referral/{其他作品id}",
    mini: "/pages/reader/reader?referral_id={其他作品id}&gzh_appid={公众号appid}",
    reg: /\/referral\/(\d+)$/,
    key: "{其他作品id}",
  },
  其它作品: {
    h5: "http://{公众号appid}.book-gzh.ledu11.cn/referral/{其他作品id}",
    mini: "/pages/reader/reader?referral_id={其他作品id}&gzh_appid={公众号appid}",
    reg: /\/referral\/(\d+)$/,
    key: "{其他作品id}",
  },
  // 签到活动
  签到活动: {
    h5: "http://{公众号appid}.book-gzh.ledu11.cn/sign-in",
    mini: "/pages/welfare/welfare?gzh_appid={公众号appid}",
  },
  //充值优惠活动
  充值优惠活动: {
    h5: "http://{公众号appid}.book-gzh.ledu11.cn/pay/pay-active/{充值活动id}",
    mini: "/pages/activity/activity?service_id={充值活动id}&gzh_appid={公众号appid}",
    reg: /\/pay-active\/(\d+)$/,
    key: "{充值活动id}",
  },
  //继续阅读
  继续阅读: {
    h5: "http://{公众号appid}.book-gzh.ledu11.cn/content-history",
    mini: "/pages/reader/reader?gzh_appid={公众号appid}&contentType=3",
  },
  // 阅读记录
  阅读记录: {
    h5: "http://{公众号appid}.book-gzh.ledu11.cn/read-record",
    mini: "/pages/tabbar/shelf/shelf?gzh_appid={公众号appid}",
  },
  // 书城首页
  书城首页: {
    h5: "http://{公众号appid}.book-gzh.ledu11.cn",
    mini: "/pages/tabbar/index/index?gzh_appid={公众号appid}",
  },
  // 排行榜
  排行榜: {
    h5: "http://{公众号appid}.book-gzh.ledu11.cn/rank",
    mini: "/pages/tabbar/index/index?gzh_appid={公众号appid}",
  },
  // 个人中心
  个人中心: {
    h5: "http://{公众号appid}.book-gzh.ledu11.cn/user-center",
    mini: "/pages/tabbar/my/my?gzh_appid={公众号appid}",
  },
  // 联系客服
  联系客服: {
    h5: "http://{公众号appid}.book-gzh.ledu11.cn/custom",
    mini: "/pages/tabbar/my/my?gzh_appid={公众号appid}&to_custom=1",
  },

  推广链接: {
    h5: "http://{公众号appid}.book-gzh.ledu11.cn/referral/{推广链接id}",
    mini: "/pages/reader/reader?referral_id={推广链接id}&gzh_appid={公众号appid}",
    reg: /\/referral\/(\d+)$/,
    key: "{推广链接id}",
  },

  女生书城: {
    h5: "http://{公众号appid}.book-gzh.ledu11.cn/female",
    mini: "/pages/tabbar/index/index?gzh_appid={公众号appid}",
  },
  充值中心: {
    h5: "http://{公众号appid}.book-gzh.ledu11.cn/pay/index",
    mini: "/pages/tabbar/my/my?gzh_appid={公众号appid}&show_pay=1",
  },

  // 活动链接
  活动链接: {
    h5: "http://{公众号appid}.book-gzh.ledu11.cn/sign-in",
    mini: "/pages/welfare/welfare?gzh_appid={公众号appid}",
  },

  小程序福利任务: {
    h5: "http://{公众号appid}.book-gzh.ledu11.cn/sign-in",
    mini: "/pages/welfare/welfare?gzh_appid={公众号appid}",
  },
  小程序:{
    mini:''
  }
};
export const isOnline = () => window.location.origin.includes("ledu");
